import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { HomeComponent } from './components/home/home.component';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { ManualLoginComponent } from './components/manual-login/manual-login.component';

import { AuthGuard } from './guards/auth.guard';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'test',
    loadChildren: () => import('../test/test.module').then(m => m.TestModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'examples',
    loadChildren: () => import('../examples/examples.module').then(m => m.ExamplesModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Examples'
    }
  },
  {
    path: 'demo1',
    loadChildren: () => import('../demo1/demo1.module').then(m => m.Demo1Module),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Demo1'
    }
  },
  {
    path: 'tabletCaseOrder',
    loadChildren: () => import('../tablet-case-order/tablet-case-order.module').then(m => m.TabletCaseOrderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'energ',
    loadChildren: () => import('../energ/energ.module').then(m => m.EnergModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home'
    }
  },
  {
    path: 'doc-review',
    loadChildren: () => import('../doc-review/doc-review.module').then(m => m.DocReviewModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Doc Review'
    }
  },
  {
    path: 'contractorAdministration',
    loadChildren: () => import('../contractor-administration/contractor-administration.module').then(m => m.ContractorAdministrationModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Contractor Administration'
    }
  },
  {
    path: 'askYourRvp',
    loadChildren: () => import('../ask-your-rvp/ask-your-rvp.module').then(m => m.AskYourRvpModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Ask Your RVP'
    }
  },
  {
    path: 'therapyIssueManager',
    loadChildren: () => import('../therapy-issue-manager/therapy-issue-manager.module').then(m => m.TherapyIssueManagerModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Therapy Issue manager'
    }
  },
  {
    path: 'aegisProcurement',
    loadChildren: () => import('../aegis-procurement/aegis-procurement.module').then(m => m.AegisProcurementModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home'
    }
  },
  {
    path: 'specialAccountsRenewal',
    loadChildren: () => import('../special-accounts-renewal/special-accounts-renewal.module').then(m => m.SpecialAccountsRenewalModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home'
    }
  },
  {
    path: 'clinicalCompetency',
    loadChildren: () => import('../clinical-competency/clinical-competency.module').then(m => m.ClinicalCompetencyModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home'
    }
  },
  {
    path: 'pfsDashboardGoals',
    loadChildren: () => import('../pfs-dashboard-goals/pfs-dashboard-goals.module').then(m => m.PfsDashboardGoalsModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'PFS Dashboard Goals'
    }
  },
  {
    path: 'incidentReport',
    loadChildren: () => import('../incident-report/incident-report.module').then(m => m.IncidentReportModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home'
    }
  },
  {
    path: 'userPermissions',
    loadChildren: () => import('../user-permissions/user-permissions.module').then(m => m.UserPermissionsModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'User Permissions'
    }
  },
  {
    path: 'facAccessTool',
    loadChildren: () => import('../fac-access-tool/fac-access-tool.module').then(m => m.facAccessToolModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Fac Access Tool'
    }
  },
  {
    path: 'adam',
    loadChildren: () => import('../adam/adam.module').then(m => m.ADAMModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'ADAM'
    }
  },
  {
    path: 'denialManager',
    loadChildren: () => import('../denial-manager/denial-manager.module').then(m => m.DenialManagerModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Denial Manager'
    }
  },
  {
    path: 'uploader',
    loadChildren: () => import('../uploader/uploader.module').then(m => m.UploaderModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Uploader'
    }
  },
  {
    path: 'directBill',
    loadChildren: () => import('../direct-bill_IVA/direct-bill.module').then(m => m.DirectBillModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'DirectBill'
    }
  },
  {
    path: 'customerinvoice',
    loadChildren: () => import('../customer-invoice/invoice.module').then(m => m.InvoiceModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Invoice'
    }
  },
  
  {
    path: 'facilityManagement',
    loadChildren: () => import('../facility-management/facility-management.module').then(m => m.FacilityManagementlModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Facility Management'
    }
  },
  {
    path: 'billing',
    loadChildren: () => import('../billing/billing.module').then(m => m.BillingModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Billing'
    }
  },
  {
    path: 'directBillTracker',
    loadChildren: () => import('../direct-bill-tracker/direct-bill-tracker.module').then(m => m.DirectBillTrackerModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'DB Tracker'
    }
  },
  {
    path: 'patientScreens',
    loadChildren: () => import('../patient-screens/patient-screens.module').then(m => m.PatientScreensModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Patient Screens'
    }
  },
  {
    path: 'wwa',
    loadChildren: () => import('../walk-with-aegis/wwa.module').then(m => m.WalkWithAegisModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Walk With Aegis'
    }
  },
  {
    path: 'afi',
    loadChildren: () => import('../aging-facility-info/afi.module').then(m => m.AgingFacilityInfoModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Aging Facility Info'
    }
  },
  {
    path: 'nh-additional',
    loadChildren: () => import('../nh-additional/nh-additional.module').then(m => m.NHAdditionalModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Net Health Additional Records'
    }
  },
  {
    path: 'monthly-checklist',
    loadChildren: () => import('../monthly-checklist/monthly-checklist.module').then(m => m.MonthlyChecklistModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Monthly Checklists'
    }
  },
  {
    path: 'consent-forms',
    loadChildren: () => import('../consent-forms/consent-forms.module').then(m => m.ConsentFormsModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Electronic Consent Forms'
    }
  },
  
  {
    path: 'nhDocBulkPrint',
    loadChildren: () => import('../nh-docs-bulk-print/nh-docs-bulk-print.module').then(m => m.NHDocBulkPrintModule),
    /*canActivate: [AuthGuard],*/
    data: {
      breadcrumb: 'NH docs Bulk print'
    }
  },
  {
    path: 'contractor',
    loadChildren: () => import('../contractor/contractor.module').then(m => m.ContractorModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'MSA Contractor Accounts'
    }
  },
  {
    path: 'scorecard',
    loadChildren: () => import('../pma/pma.module').then(m => m.PMAModule),
   canActivate: [AuthGuard],
    data: {
      breadcrumb: 'My Quality Scorecard'
    }
  },
  {
    path: 'db-reconciliation',
    loadChildren: () => import('../direct-bill-reconciliation/direct-bill-reconciliation.module').then(m => m.DirectBillReconciliationModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Direct Bill Reconciliation'
    }
  },
  {
    path: 'nh-invoice-export',
    loadChildren: () => import('../nh-invoice-export/nh-invoice-export.module').then(m => m.NhInvoiceExportModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'NH Invoice Export'
    }
  },
  {
    path: 'fall-reporting',
    loadChildren: () => import('../fall-reporting/fall-reporting.module').then(m => m.FallReportingModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Fall Reporting'
    }
  },
  {
    path: 'sessionexpired',
    component: SessionExpiredComponent
  },
  {
    path: 'manuallogin',
    component: ManualLoginComponent
  },
  {
    path: 'accessdenied',
    component: AccessDeniedComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  declarations: []
})
export class CoreRoutingModule { }
